import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/layout/Navbar';
import { Footer } from './components/layout/Footer';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { HowItWorksPage } from './pages/HowItWorksPage';
import { TestimonialsPage } from './pages/TestimonialsPage';
import { ForEmployersPage } from './pages/ForEmployersPage';
import { ContactPage } from './pages/ContactPage';
import { BlogPage } from './pages/BlogPage';
// ScrollToTop component to handle scroll restoration
import { useLocation } from 'react-router-dom';
function ScrollToTop() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      // Defer to ensure the target element is mounted
      const id = hash.replace('#', '');
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        } else {
          window.scrollTo(0, 0);
        }
      }, 50);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
}
export function App() {
  return <Router data-id="element-0" data-mp="3rcsulke91w9o">
      <ScrollToTop data-id="element-1" data-mp="3recedkz46pg7" />
      <div className="flex flex-col min-h-screen bg-gray-50 font-sans text-gray-900" data-id="element-2" data-mp="5yi8qe3h5da">
        <Navbar data-id="element-3" data-mp="7svdij4jt6t" />
        <main className="flex-grow" data-id="element-4" data-mp="2zld0l5ad579f">
          <Routes data-id="element-5" data-mp="2zmepackaxs9m">
            <Route path="/" element={<HomePage data-id="element-7" data-mp="2zng1wlgyumtg" />} data-id="element-6" data-mp="2zmwj72jhrued" />
            <Route path="/about" element={<AboutPage data-id="element-9" data-mp="33ngfk3w8qtzg" />} data-id="element-8" data-mp="33m5c656pjo8v" />
            <Route path="/how-it-works" element={<HowItWorksPage data-id="element-11" data-mp="38l8j5v6904jh" />} data-id="element-10" data-mp="33orki71fa7s5" />
            <Route path="/testimonials" element={<TestimonialsPage data-id="element-13" data-mp="38o4edbqpof48" />} data-id="element-12" data-mp="38l017ov9q91f" />
            <Route path="/employers" element={<ForEmployersPage data-id="element-15" data-mp="3dmfpdpsqsvo1" />} data-id="element-14" data-mp="3dl4lzr37lpxg" />
            <Route path="/contact" element={<ContactPage data-id="element-17" data-mp="nwc0jp6vnpuo" />} data-id="element-16" data-mp="nvj5hlha6osd" />
            <Route path="/blog" element={<BlogPage data-id="element-19" data-mp="nxwv3et6z8sj" />} data-id="element-18" data-mp="nv0x5qhcgk43" />
          </Routes>
        </main>
        <Footer data-id="element-20" data-mp="stc7017n2umb" />
      </div>
    </Router>;
}